module.exports = __webpack_public_path__ + "img/sugarrush.b358efd6.gif";